import React from 'react'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  statcard: {
    height: "100%",
    width: "100%",
    padding: theme.spacing(1)
  }
})

const StatCard = ({ children, title, description, classes }) => {
  return (
    <Paper className={"card-stats" + (this.props.className !== undefined ? " " + this.props.className:"")}>
        {title}
        {children}
        {description}
    </Paper>
  )
}

export default withStyles(styles, {withTheme: true})(StatCard)